import FieldGroup from "../../../components/base/forms/field-group";

export default class FeedbackFieldGroup extends FieldGroup {
	constructor(...props) {
		super(...props);
		this.init();
	}

	init() {
		if (this.options.initialValues) {
			this.fields.course.setInitialValue(this.options.initialValues['course']);
		}

		this.addEventListeners();
	}

	addEventListeners() {
		this.fields.course.subscribe('valueChange', (e) => {
			this.refreshCoachesField();
		})
	}

	refreshCoachesField() {
		if (this.fields.course.value != null) {
			this.fields.coaches.fetchCoachesList(this.fields.course.value);
		} else {
			this.fields.coaches.setInitialState();
		}
	}
}